// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RfW3","name":"styles_name__32pWg","phone":"styles_phone__2eSAH"};